import { Storage, Auth } from 'aws-amplify'
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3'
import keys from '@/config/keys'

export const s3Upload = async (file, awsUserId, filename = 'picture.png') => {
  filename = `${Date.now()}-${file.name || filename}`
  const stored = await Storage.vault.put(filename, file, {
    contentType: file.type,
  })
  return `https://${keys.s3.BUCKET}.s3.amazonaws.com/private/${awsUserId}/${stored.key}`
}

// Uses @aws-sdk/client-s3 directly to avoid Amplify adding ACL: public-read,
// which fails on buckets with ObjectOwnership: BucketOwnerEnforced.
// Public read is granted via a bucket policy on the public/ prefix instead.
export const s3UploadPublic = async (file, filename = 'picture.png') => {
  filename = `public/emails/${Date.now()}-${file.name || filename}`
  const credentials = await Auth.currentCredentials()
  const s3 = new S3Client({
    region: keys.s3.REGION,
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken,
    },
  })
  await s3.send(new PutObjectCommand({
    Bucket: keys.s3.BUCKET,
    Key: filename,
    Body: file,
    ContentType: file.type,
  }))
  return `https://${keys.s3.BUCKET}.s3.amazonaws.com/${filename}`
}
